export const SET_GOOGLE_MAP = 'SET_GOOGLE_MAP';
export const SET_RESULT_SELECTED = 'SET_RESULT_SELECTED';
export const SET_RESULT_HOVERED = 'SET_RESULT_HOVERED';
export const SET_MAP_CONTROLLED = 'SET_MAP_CONTROLLED';
export const SET_SHOW_INFOBOX = 'SET_SHOW_INFOBOX';
export const SET_MAP_LOCATION = 'SET_MAP_LOCATION';
export const ADJUST_WINDOW_SHADE = 'ADJUST_WINDOW_SHADE'
export const MAP_DRAG = 'MAP_DRAG';

const setGoogleMap = (mapComponent) => ({
    type: SET_GOOGLE_MAP,
    payload: { mapComponent }
});

import { createAction } from 'redux-actions';

const setResultSelected = createAction(SET_RESULT_SELECTED, (selected) => ({selected}));
const setResultHovered = createAction(SET_RESULT_HOVERED, (hovered) => ({hovered}));
const setShowInfobox = createAction(SET_SHOW_INFOBOX, (show_infobox) => ({show_infobox}));
const setMapControlled = createAction(SET_MAP_CONTROLLED, (map_controlled) => ({map_controlled}));

const POSITIONS = ['min', 'mid', 'max']
const adjustWindowShade = createAction(
	ADJUST_WINDOW_SHADE,
	direction => ({
		direction
	}))

import { createProgressActions, createActionCreators } from '../utils';
const dragMap = createActionCreators(createProgressActions('DRAG'));

import { Coord } from '../Location/mapUtils';
const setMapLocation = createAction(SET_MAP_LOCATION, (mapLocation)=> {
  const { lat, lng } = new Coord(mapLocation);

	return { lat, lng, zoom: mapLocation.zoom }
});

export {
 setGoogleMap,
 setResultSelected,
 setResultHovered,
 setShowInfobox,
 setMapControlled,
 setMapLocation,
 dragMap,
 adjustWindowShade,
}



// WEBPACK FOOTER //
// ./src/app/models/Map/actions.ts